import { Button, Select ,Row,
  Col,Carousel,CarouselItem,Image,Card,Input,MenuItem,Menu,Tabs,TabPane,Radio,RadioGroup,RadioButton, PageHeader,Drawer,Dialog,MessageBox, Message,} from 'element-ui';
const element = {
  install: function (Vue) {
    Vue.use(Button)
Vue.use(Select)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Card)
Vue.use(Input)
Vue.use(MenuItem)
Vue.use(Menu)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Radio) 
Vue.use(RadioGroup) 
Vue.use(RadioButton)
Vue.use(PageHeader)
Vue.use(Drawer)
Vue.use(Dialog)


Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.prototype.$message = Message;

  }

  
}
export default element

